'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('manageusers', {
      url: '/admin/manageusers',
      template: '<manageusers></manageusers>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/manageusers/manageusers.routes.js